import React from 'react'
import style from "../Content.module.css";
import {
    Button,
    Form,
    Input,
    Row,
    Col,
    DatePicker,
    Select,
    Space,
    Table,
    Modal,
    message,
    Checkbox,
    Image,
    Tabs,
} from "antd";
import Axios from "../../../utils/axios";
import Util from "../../../utils/utils";
import zh_CN from 'antd/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import {ExclamationCircleOutlined} from "@ant-design/icons";
import ResizableTitle from "../../../utils/ResizableTitle";
import "../../../utils/date"
import PATH_URL from "../../../utils/url";
import {fetchAllIdsInParallel} from "../../../utils/fetchAllIds";

moment.locale('zh-cn');
const qs = require('qs');
const {RangePicker} = DatePicker;
const {TextArea} = Input;
const {TabPane} = Tabs;
let userName = null;
let userRole = null;
const todayDate = new Date();
const today = todayDate.getFullYear() + "-" + Util.fillZero(todayDate.getMonth() + 1) + "-" + Util.fillZero(todayDate.getDate());

class OrderInfo extends React.Component {
    addFormRef = React.createRef();
    viewFormRef = React.createRef();
    editFormRef = React.createRef();
    state = {
        data: null,
        siteData: null,
        allSiteData: null,
        carModelData: null,
        allGroupUserData: null,
        groupUser: null,
        orderByGroupUser: null,
        loading: true,
        current: 1,
        pageSize: 10,
        total: 0,
        sortField: 'orderTime',
        sortType: 'descend',
        colWidths: {},
        licensePlate: '',
        ownerName: '',
        ownerTel: '',
        siteName: '',
        orderStartTime: '',
        orderEndTime: '',
        status: '',
        source: '',
        sourceList: [],
        carModel: '',
        orderBy: '',
        orderByName: '',
        groupUserRealName: null,
        groupUserName: null,
        completeStartTime: '',
        completeEndTime: '',
        registrationStartTime: '',
        registrationEndTime: '',
        orderCreateStartTime: '',
        orderCreateEndTime: '',
        remarks: '',
        // 统一筛选状态（需求：时间4类合并下拉、8字段合并统一搜索）
        timeType: 'orderTime',
        timeRange: [],
        searchField: 'licensePlate',
        searchValue: '',
        isToDayOrderClick: false,
        addVisible: false,
        viewVisible: false,
        editVisible: false,
        isExporting: false,
        selectedRowKeys: [],
        userPermission: null,
        selected: [],
        checkboxText: '全选',
        isCheckAll: false,
        selectAllLoading: false,
        selectAllProgress: 0,
        qrCodeVisible: false,
        qrCodeImage: null,
        monthExportVisible: false,
        monthExportYear: null,
        monthExportMonth: null,
        isMonthExporting: false,
    }

    constructor(props) {
        super(props);
        userRole = JSON.parse(window.sessionStorage.getItem("userRole"));
        if (userRole === 6) {
            Axios({
                method: 'get',
                url: PATH_URL.GET_USER_INFO_URL + "/" + JSON.parse(window.sessionStorage.getItem("userName")),
            }).then(res => {
                if (res.data.code === 200) {
                    this.setState({
                        orderByGroupUser: res.data.data.invitationUser
                    })
                } else {
                    message.error(res.data.message);
                }
            }).catch(err => {
                console.log(err);
            });
        }
    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return
        }
    }

    componentDidMount() {
        userName = JSON.parse(window.sessionStorage.getItem("userName"));
        if (!Util.isEmpty(userName)) {
            this.getUserPermission();
            this.initSiteDate();
            this.initAllSiteDate();
            this.initCarModelDate();
            this.initGroupUserDate();
        }
    }

    getUserPermission = () => {
        Axios({
            method: 'get',
            url: '/menu/getUserMenu/' + JSON.parse(window.sessionStorage.getItem("userName")),
        }).then(res => {
            if (res.data.code === 200) {
                const sourceList = this.state.sourceList;
                if (res.data.data.length > 0) {
                    if (res.data.data.includes('300039')) {
                        sourceList.push(0)
                    }
                    if (res.data.data.includes('300040')) {
                        sourceList.push(1)
                    }
                    if (res.data.data.includes('300041')) {
                        sourceList.push(2)
                    }
                    if (res.data.data.includes('300042')) {
                        sourceList.push(4)
                    }
                    if (res.data.data.includes('300073')) {
                        sourceList.push(5)
                    }
                }
                this.setState({
                    userPermission: res.data.data,
                    sourceList: sourceList
                });
                this.initData();
            } else {
                message.error(res.data.message);
            }
        }).catch(err => {
            console.log(err);
        });
    }
    exportAllSelect = (e) => {
        const checked = e.target.checked;
        this.setState({
            isCheckAll: checked,
            selectAllProgress: 0,
        });
        if (checked) {
            const hide = message.loading('正在全选，请稍候…', 0);
            this.setState({selectAllLoading: true});
            const afterDone = () => {
                hide();
                this.setState({selectAllLoading: false});
            };
            const success = (ids) => {
                afterDone();
                if (Array.isArray(ids) && ids.length > 0) {
                    this.setState({
                        selectedRowKeys: ids.sort(function (a, b) {
                            return a - b
                        }),
                        checkboxText: '取消全选',
                        selectAllProgress: 100,
                    });
                    message.success('已全选 ' + ids.length + ' 条订单');
                } else {
                    this.setState({isCheckAll: false});
                    message.info('没有符合要求的数据');
                }
            };
            const fail = (msg) => {
                afterDone();
                this.setState({isCheckAll: false, selectAllProgress: 0});
                if (msg) {
                    message.info(msg);
                } else {
                    message.error('全选失败，请重试');
                }
            };
            // 并发分批拉取所有符合条件的订单ID，实时更新进度百分比
            const PAGE_SIZE = 2000;
            const fetchAllPage = (params) => {
                const fetchPage = (pageNum) => {
                    return new Promise((resolve, reject) => {
                        Axios({
                            method: 'get',
                            url: '/order/listOrderInfoIdsPage',
                            params: Object.assign({}, params, {pageNum: pageNum, pageSize: PAGE_SIZE}),
                            paramsSerializer: function (params2) {
                                return qs.stringify(params2, {arrayFormat: 'repeat'})
                            }
                        }).then(res => {
                            if (res.status === 200 && res.data.code === 200) {
                                const data = res.data.data;
                                resolve({
                                    total: data ? (Number(data.total) || 0) : 0,
                                    list: (data && Array.isArray(data.list)) ? data.list : []
                                });
                            } else if (res.status === 200 && res.data.code === 401) {
                                reject(new Error('401'));
                            } else {
                                reject(new Error(res.data.message || '没有符合要求的数据'));
                            }
                        }).catch(err => {
                            reject(err);
                        });
                    });
                };
                fetchAllIdsInParallel(fetchPage, PAGE_SIZE, percent => {
                    this.setState({selectAllProgress: percent});
                }).then(ids => {
                    success(ids);
                }).catch(err => {
                    console.log(err);
                    let msg = '';
                    if (err && err.message) {
                        msg = err.message;
                    } else if (err && err.data) {
                        msg = err.data.message || err.data.msg || '';
                    } else if (err && err.status) {
                        msg = '请求失败(' + err.status + ')';
                    }
                    fail(msg && msg !== '401' ? msg : undefined);
                });
            };
            if (userRole === 3) {
                Axios({
                    method: 'get',
                    url: '/site/getSiteByUserName/' + userName,
                }).then(res => {
                    if (res.status === 200) {
                        if (res.data.code === 200) {
                            if (!Util.isEmpty(res.data.data.siteName)) {
                                fetchAllPage({
                                    orderBy: this.state.orderBy,
                                    orderByName: this.state.orderByName,
                                    licensePlate: this.state.licensePlate,
                                    ownerName: this.state.ownerName,
                                    ownerTel: this.state.ownerTel,
                                    siteName: res.data.data.siteName,
                                    orderStartTime: this.state.orderStartTime,
                                    orderEndTime: this.state.orderEndTime,
                                    status: this.state.status,
                                    source: this.state.source,
                                    carModel: this.state.carModel,
                                    completeStartTime: this.state.completeStartTime,
                                    completeEndTime: this.state.completeEndTime,
                                    registrationStartTime: this.state.registrationStartTime,
                                    registrationEndTime: this.state.registrationEndTime,
                                    orderCreateStartTime: this.state.orderCreateStartTime,
                                    orderCreateEndTime: this.state.orderCreateEndTime
                                });
                            } else {
                                afterDone();
                                this.setState({isCheckAll: false, selectAllProgress: 0});
                                message.info('当前账号未绑定站点，无法全选');
                            }
                        } else {
                            fail();
                        }
                    } else if (res.code === 401) {
                        fail();
                    }
                }).catch(err => {
                    console.log(err);
                    fail();
                });
            } else {
                fetchAllPage({
                    orderBy: userRole === 4 ? this.state.orderBy : (this.state.orderBy === '' ? userName : this.state.orderBy),
                    isOrderByName: this.state.orderBy === '' ? false : true,
                    orderByName: this.state.orderByName,
                    licensePlate: this.state.licensePlate,
                    ownerName: this.state.ownerName,
                    ownerTel: userRole === 4 ? (this.state.ownerTel === '' ? userName : this.state.ownerTel) : this.state.ownerTel,
                    siteName: this.state.siteName,
                    groupUserRealName: this.state.groupUserRealName,
                    groupUserName: this.state.groupUserName,
                    orderStartTime: this.state.orderStartTime,
                    orderEndTime: this.state.orderEndTime,
                    status: this.state.status,
                    source: this.state.source,
                    sourceList: userRole === 0 && this.state.sourceList.length > 0 ? this.state.sourceList : undefined,
                    carModel: this.state.carModel,
                    completeStartTime: this.state.completeStartTime,
                    completeEndTime: this.state.completeEndTime,
                    registrationStartTime: this.state.registrationStartTime,
                    registrationEndTime: this.state.registrationEndTime,
                    orderCreateStartTime: this.state.orderCreateStartTime,
                    orderCreateEndTime: this.state.orderCreateEndTime
                });
            }
        } else {
            const selected = this.state.selected;
            this.setState({
                selectedRowKeys: selected,
                checkboxText: '全选',
                selectAllProgress: 0,
            });
        }
    }

    initData() {
        if (userRole === 3) {
            Axios({
                method: 'get',
                url: '/site/getSiteByUserName/' + userName,
            }).then(res => {
                if (res.status === 200) {
                    if (res.data.code === 200) {
                        if (!Util.isEmpty(res.data.data.siteName)) {
                            Axios({
                                method: 'get',
                                url: '/order/listOrderInfo',
                                params: {
                                    orderBy: this.state.orderBy,
                                    orderByName: this.state.orderByName,
                                    licensePlate: this.state.licensePlate,
                                    ownerName: this.state.ownerName,
                                    ownerTel: this.state.ownerTel,
                                    siteName: res.data.data.siteName,
                                    orderStartTime: this.state.orderStartTime,
                                    orderEndTime: this.state.orderEndTime,
                                    status: this.state.status,
                                    source: this.state.source,
                                    carModel: this.state.carModel,
                                    completeStartTime: this.state.completeStartTime,
                                    completeEndTime: this.state.completeEndTime,
                                    registrationStartTime: this.state.registrationStartTime,
                                    registrationEndTime: this.state.registrationEndTime,
                                    orderCreateStartTime: this.state.orderCreateStartTime,
                                    orderCreateEndTime: this.state.orderCreateEndTime,
                                    remarks: this.state.remarks.length > 50 ? null : this.state.remarks,
                                    sortField: this.state.sortField === 'completeTime' ? 'complete_time' : this.state.sortField === 'gmtCreate' ? 'gmt_create' : 'order_time',
                                    sortType: this.state.sortType,
                                    pageNum: this.state.current,
                                    pageSize: this.state.pageSize
                                }
                            }).then(res => {
                                if (res.status === 200) {
                                    if (res.data.code === 200) {
                                        this.setState({
                                            data: res.data.data.list,
                                            loading: false,
                                            total: res.data.data.total,
                                        });
                                    } else {
                                        this.setState({
                                            loading: false,
                                        });
                                        message.error(res.data.message);
                                    }
                                } else if (res.code === 401) {
                                    this.setState({
                                        loading: false,
                                    });
                                    message.error(res.message);
                                }
                            }).catch(err => {
                                this.setState({
                                    loading: false,
                                });
                                console.log(err);
                            });
                        }
                    } else {
                        message.error(res.data.message);
                    }
                } else if (res.code === 401) {
                    message.error(res.message);
                }
            }).catch(err => {
                console.log(err);
            });
        } else {
            Axios({
                method: 'get',
                url: '/order/listOrderInfo',
                params: {
                        orderBy: userRole === 6 ? this.state.orderByGroupUser : (userRole === 4 ? this.state.orderBy : (this.state.orderBy === '' ? userName : this.state.orderBy)),
                        isOrderByName: this.state.orderBy === '' ? false : true,
                        orderByName: this.state.orderByName,
                        groupUser: userRole === 6 ? userName : this.state.groupUser,
                        licensePlate: this.state.licensePlate,
                        ownerName: this.state.ownerName,
                        ownerTel: userRole === 4 ? (this.state.ownerTel === '' ? userName : this.state.ownerTel) : this.state.ownerTel,
                    siteName: this.state.siteName,
                    groupUserRealName: this.state.groupUserRealName,
                    groupUserName: this.state.groupUserName,
                    orderStartTime: this.state.orderStartTime,
                    orderEndTime: this.state.orderEndTime,
                    status: this.state.status,
                    source: this.state.source,
                    sourceList: userRole === 0 ? (this.state.sourceList.length === 0 ? [-1] : this.state.sourceList) : null,
                    carModel: this.state.carModel,
                    completeStartTime: this.state.completeStartTime,
                    completeEndTime: this.state.completeEndTime,
                    registrationStartTime: this.state.registrationStartTime,
                    registrationEndTime: this.state.registrationEndTime,
                    orderCreateStartTime: this.state.orderCreateStartTime,
                    orderCreateEndTime: this.state.orderCreateEndTime,
                    remarks: this.state.remarks.length > 50 ? null : this.state.remarks,
                    sortField: this.state.sortField === 'completeTime' ? 'complete_time' : this.state.sortField === 'gmtCreate' ? 'gmt_create' : 'order_time',
                    sortType: this.state.sortType,
                    pageNum: this.state.current,
                    pageSize: this.state.pageSize
                },
                paramsSerializer: function (params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                }
            }).then(res => {
                if (res.status === 200) {
                    if (res.data.code === 200) {
                        this.setState({
                            data: res.data.data.list,
                            loading: false,
                            total: res.data.data.total,
                        });
                    } else {
                        this.setState({
                            loading: false,
                        });
                        message.error(res.data.message);
                    }
                } else if (res.code === 401) {
                    this.setState({
                        loading: false,
                    });
                    message.error(res.message);
                }
            }).catch(err => {
                this.setState({
                    loading: false,
                });
                console.log(err);
            });
        }
    }

    inputChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        }, () => {
            this.searchOrder();
        });
    }
    handleTimeSelect = (value) => {
        this.setState({
            timeRange: value,
        }, () => {
            this.searchOrder();
        })
    }
    timeTypeChange = (value) => {
        this.setState({
            timeType: value,
        }, () => {
            this.searchOrder();
        })
    }
    searchFieldChange = (value) => {
        this.setState({
            searchField: value,
        }, () => {
            this.searchOrder();
        })
    }
    statusChange = (value) => {
        this.setState({
            status: value,
        }, () => {
            this.searchOrder();
        })
    }
    siteChange = (value) => {
        this.setState({
            siteName: value,
        }, () => {
            this.searchOrder();
        })
    }
    sourceChange = (value) => {
        this.setState({
            source: value,
        }, () => {
            this.searchOrder();
        })
    }
    initAllSiteDate = () => {
        Axios({
            method: 'get',
            url: '/site/listAllSiteNoPage',
        }).then(res => {
            if (res.status === 200) {
                if (res.data.code === 200) {
                    this.setState({
                        allSiteData: res.data.data,
                    });
                } else {
                    message.error(res.data.message);
                }
            } else if (res.code === 401) {
                message.error(res.message);
            }
        }).catch(err => {
            console.log(err);
        });
    }
    initSiteDate = () => {
        Axios({
            method: 'get',
            url: '/site/listSiteNoPage',
            params: {
                siteName: this.state.siteName,
            }
        }).then(res => {
            if (res.status === 200) {
                if (res.data.code === 200) {
                    this.setState({
                        siteData: res.data.data,
                    });
                } else {
                    message.error(res.data.message);
                }
            } else if (res.code === 401) {
                message.error(res.message);
            }
        }).catch(err => {
            console.log(err);
        });
    }
    initGroupUserDate = () => {
        Axios({
            method: 'get',
            url: '/user/listGroupUser/' + JSON.parse(window.sessionStorage.getItem("userName")),
        }).then(res => {
            if (res.status === 200) {
                if (res.data.code === 200) {
                    let other = {};
                    other.userName = JSON.parse(window.sessionStorage.getItem("userName"));
                    other.groupName = "其他";
                    let data = res.data.data;
                    data.push(other);
                    this.setState({
                        allGroupUserData: data
                    });
                } else {
                    message.error(res.data.message);
                }
            } else if (res.code === 401) {
                message.error(res.message);
            }
        }).catch(err => {
            console.log(err);
        });
    }
    initCarModelDate = () => {
        Axios({
            method: 'get',
            url: '/carModel/listCarModelNoPage',
        }).then(res => {
            if (res.status === 200) {
                if (res.data.code === 200) {
                    this.setState({
                        carModelData: res.data.data,
                    });
                } else {
                    message.error(res.data.message);
                }
            } else if (res.code === 401) {
                message.error(res.message);
            }
        }).catch(err => {
            console.log(err);
        });
    }
    resetSearch = () => {
        this.setState({
            licensePlate: '',
            ownerName: '',
            ownerTel: '',
            siteName: '',
            orderBy: '',
            orderByName: '',
            orderStartTime: '',
            orderEndTime: '',
            status: '',
            source: '',
            carModel: '',
            completeStartTime: '',
            completeEndTime: '',
            registrationStartTime: '',
            registrationEndTime: '',
            orderCreateStartTime: '',
            orderCreateEndTime: '',
            remarks: '',
            groupUser: null,
            groupUserRealName: null,
            groupUserName: null,
            timeType: 'orderTime',
            timeRange: [],
            searchField: 'licensePlate',
            searchValue: '',
            loading: true,
        });
        // 重置后按清空条件重新加载数据（loading 提供过程感知，避免误以为无效）
        setTimeout(() => {
            this.initData();
        }, 100);
    }
    searchOrder = () => {
        // 统一时间筛选：按所选时间类型将 timeRange 映射到对应时间字段，未选择则清空全部时间字段
        const t = this.state.timeRange;
        const timePatch = {
            orderStartTime: '', orderEndTime: '',
            completeStartTime: '', completeEndTime: '',
            registrationStartTime: '', registrationEndTime: '',
            orderCreateStartTime: '', orderCreateEndTime: '',
        };
        if (t != null && t.length === 2 && t[0] && t[1]) {
            // timeRange 存储的是 moment 对象数组（受控 value），查询时格式化为后端所需字符串
            // 时间选择器不含时分秒，故开始日取 00:00:00、结束日取 23:59:59 覆盖全天
            // 注：registration_time 为 varchar 且存量数据多为纯日期（YYYY-MM-DD），
            // 若开始时间带时分秒（YYYY-MM-DD 00:00:00），字符串比较会排除纯日期值，
            // 故开始时间传纯日期、结束时间传 23:59:59，可同时覆盖纯日期与带时分秒两种格式
            const fmtStart = (m) => m.format('YYYY-MM-DD 00:00:00');
            const fmtEnd = (m) => m.format('YYYY-MM-DD 23:59:59');
            const fmtDay = (m) => m.format('YYYY-MM-DD');
            switch (this.state.timeType) {
                case 'completeTime':
                    timePatch.completeStartTime = fmtStart(t[0]);
                    timePatch.completeEndTime = fmtEnd(t[1]);
                    break;
                case 'registrationTime':
                    timePatch.registrationStartTime = fmtDay(t[0]);
                    timePatch.registrationEndTime = fmtEnd(t[1]);
                    break;
                case 'orderCreateTime':
                    timePatch.orderCreateStartTime = fmtStart(t[0]);
                    timePatch.orderCreateEndTime = fmtEnd(t[1]);
                    break;
                default:
                    timePatch.orderStartTime = fmtStart(t[0]);
                    timePatch.orderEndTime = fmtEnd(t[1]);
            }
        }
        // 统一搜索：按所选标签将输入值映射到对应字段，其余搜索字段清空
        const fieldMap = {
            licensePlate: 'licensePlate', ownerName: 'ownerName', ownerTel: 'ownerTel',
            carModel: 'carModel', orderByName: 'orderByName', orderBy: 'orderBy',
            groupUserName: 'groupUserName', groupUserRealName: 'groupUserRealName',
        };
        const searchPatch = {
            licensePlate: '', ownerName: '', ownerTel: '', carModel: '',
            orderByName: '', orderBy: '', groupUserName: '', groupUserRealName: '',
        };
        if (this.state.searchValue !== '') {
            searchPatch[fieldMap[this.state.searchField]] = this.state.searchValue;
        }
        if (this.state.isToDayOrderClick) {
            this.setState({
                isToDayOrderClick: false,
                orderStartTime: this.state.orderStartTime === (today + " 00:00:00") ? null : this.state.orderStartTime,
                orderEndTime: this.state.orderEndTime === (today + " 23:59:59") ? null : this.state.orderEndTime,
            })
        }
        this.setState({
            ...timePatch,
            ...searchPatch,
            loading: true,
        });
        // 设置100毫秒的延迟
        setTimeout(() => {
            this.initData();
        }, 100);
    }
    searchTheSameDayOrder = () => {
        this.setState({
            loading: true,
            isToDayOrderClick: true,
            timeType: 'orderTime',
            timeRange: [moment(today + " 00:00:00", 'YYYY-MM-DD HH:mm:ss'), moment(today + " 23:59:59", 'YYYY-MM-DD HH:mm:ss')],
            // 直接按"预约时间=今天"查询，无需再到时间筛选区点查询
            orderStartTime: today + " 00:00:00",
            orderEndTime: today + " 23:59:59",
            // 清空其他时间筛选，避免旧条件叠加影响
            completeStartTime: '',
            completeEndTime: '',
            registrationStartTime: '',
            registrationEndTime: '',
            orderCreateStartTime: '',
            orderCreateEndTime: '',
        });
        // 设置100毫秒的延迟
        setTimeout(() => {
            this.initData();
        }, 100);
    }
    handleCancel = () => {
        this.setState({
            viewVisible: false,
            editVisible: false,
            addVisible: false,
            qrCodeVisible: false,
        });
        if (this.addFormRef.current != null) {
            this.addFormRef.current.resetFields();
        }
        if (this.editFormRef.current != null) {
            this.editFormRef.current.resetFields();
        }
        if (this.viewFormRef.current != null) {
            this.viewFormRef.current.resetFields();
        }
    }
    showAddOrder = () => {
        this.setState({
            addVisible: true,
        });
    }
    showOrder = (record) => {
        this.setState({
            viewVisible: true,
        });
        // 设置100毫秒的延迟 确保from组件已经加载完毕
        setTimeout(() => {
            if (userRole === 3) {
                record.ownerTel = record.ownerTel.replace(/^(\d{3})\d{4}(\d{4})$/, "$1****$2");
            }
            if (record.registrationTime) {
                const m = moment(record.registrationTime);
                record.registrationTime = m.isValid() ? m.format('YYYY-MM-DD') : record.registrationTime;
            }
            this.viewFormRef.current.setFieldsValue(record);
        }, 100);
    }
    showEditOrder = (record) => {
        this.setState({
            editVisible: true,
        });
        record.registrationTime = moment(record.registrationTime);
        record.orderTime = moment(record.orderTime);
        record.registrationTime = moment(record.registrationTime);
        // 设置100毫秒的延迟 确保from组件已经加载完毕
        setTimeout(() => {
            this.editFormRef.current.setFieldsValue(record);
        }, 100);
    }
    showCancelOrder = (record) => {
        Modal.confirm({
            icon: <ExclamationCircleOutlined/>,
            content: "确认取消该订单？",
            onOk: () => {
                Axios({
                    method: 'post',
                    url: '/order/cancelOrderInfo/' + record.id,
                    params: {}
                }).then(res => {
                    if (res.status === 200) {
                        if (res.data.code === 200) {
                            message.success(res.data.message);
                            this.initData();
                        } else {
                            message.error(res.data.message);
                        }
                    } else if (res.code === 401) {
                        message.error(res.message);
                    }
                }).catch(err => {
                    console.log(err);
                });
            },
            onCancel: () => {

            },
        });
    }
    showChangeOrderStatus = (record, status) => {
        Modal.confirm({
            icon: <ExclamationCircleOutlined/>,
            content: "确认修改该订单状态？",
            onOk: () => {
                Axios({
                    method: 'post',
                    url: '/order/changeOrderStatus/' + record.id + "/" + status,
                }).then(res => {
                    if (res.status === 200) {
                        if (res.data.code === 200) {
                            message.success(res.data.message);
                            this.initData();
                        } else {
                            message.error(res.data.message);
                        }
                    } else if (res.code === 401) {
                        message.error(res.message);
                    }
                }).catch(err => {
                    console.log(err);
                });
            },
            onCancel: () => {

            },
        });
    }
    addOrder = () => {
        this.addFormRef.current.validateFields().then(values => {
            if (userRole === 6) {
                values.orderBy = this.state.orderByGroupUser;
            } else {
                values.orderBy = userName;
            }
            values.registrationTime = new Date(values.registrationTime).format("yyyy-MM-dd");
            values.orderTime = new Date(values.orderTime).format("yyyy-MM-dd hh:mm:ss");
            if (userRole === 5 || userRole === 6) {
                values.groupUser = userName;
            }
            Axios({
                method: 'post',
                url: '/order/addOrderInfo',
                data: JSON.stringify(values)
            }).then(res => {
                if (res.status === 200) {
                    if (res.data.code === 200) {
                        this.setState({
                            loading: true,
                            addVisible: false,
                        });
                        message.success(res.data.message);
                        this.initData();
                        this.addFormRef.current.resetFields();
                    } else {
                        message.error(res.data.message);
                    }
                } else if (res.code === 401) {
                    message.error(res.message);
                }
            }).catch(err => {
                console.log(err);
            });
        }).catch(info => {
            console.log(info);
        });
    }
    updateOrder = () => {
        this.editFormRef.current.validateFields().then(values => {
            values.orderTime = new Date(values.orderTime).format("yyyy-MM-dd hh:mm:ss");
            values.registrationTime = new Date(values.registrationTime).format("yyyy-MM-dd");
            Axios({
                method: 'post',
                url: '/order/updateOrderInfo',
                data: JSON.stringify(values)
            }).then(res => {
                if (res.status === 200) {
                    if (res.data.code === 200) {
                        this.setState({
                            loading: true,
                            editVisible: false,
                        });
                        message.success(res.data.message);
                        this.initData();
                        this.editFormRef.current.resetFields();
                    } else {
                        message.error(res.data.message);
                    }
                } else if (res.code === 401) {
                    message.error(res.message);
                }
            }).catch(err => {
                console.log(err);
            });
        }).catch(info => {
            console.log(info);
        });
    }
    showDeleteOrder = (record) => {
        Modal.confirm({
            icon: <ExclamationCircleOutlined/>,
            content: "确认删除该订单？",
            onOk: () => {
                Axios({
                    method: 'delete',
                    url: '/order/deleteOrderInfo/' + record.id,
                    params: {}
                }).then(res => {
                    if (res.status === 200) {
                        if (res.data.code === 200) {
                            message.success(res.data.message);
                            this.initData();
                        } else {
                            message.error(res.data.message);
                        }
                    } else if (res.code === 401) {
                        message.error(res.message);
                    }
                }).catch(err => {
                    console.log(err);
                });
            },
            onCancel: () => {

            },
        });
    }
    onSelectChange = (selectedRowKeys) => {
        const selected = this.state.selectedRowKeys;
        if (selectedRowKeys.length > 0) {
            selectedRowKeys.forEach(item => {
                if (selected.indexOf(item) < 0) {
                    selected.push(item);
                }
            });
        }
        this.setState({
            selected: selectedRowKeys.sort(function (a, b) {
                return a - b
            }),
            selectedRowKeys: selected.sort(function (a, b) {
                return a - b
            }),
        });
        if (this.state.selectedRowKeys.length === 0) {
            this.setState({
                isCheckAll: false,
                checkboxText: '全选',
            })
        }
    }
    rowOnSelect = (record, selected, selectedRows, nativeEvent) => {
        const selectedRowKeys = this.state.selectedRowKeys;
        if (selected === true) {
            selectedRowKeys.push(record.id);
        } else {
            const index = selectedRowKeys.indexOf(record.id);
            if (index >= 0) {
                selectedRowKeys.splice(index, 1);
            }
        }
        this.setState({
            selected: selectedRowKeys.sort(function (a, b) {
                return a - b
            }),
            selectedRowKeys: selectedRowKeys.sort(function (a, b) {
                return a - b
            }),
        });
    }
    onSelectAll = (selected, selectedRows, changeRows) => {
        if (!selected) {
            const selectedRowKeys = this.state.selectedRowKeys;
            for (let i = 0; i < changeRows.length; i++) {
                const index = selectedRowKeys.indexOf(changeRows[i].id);
                selectedRowKeys.splice(index, 1);
            }
            this.setState({
                selected: selectedRowKeys.sort(function (a, b) {
                    return a - b
                }),
                selectedRowKeys: selectedRowKeys.sort(function (a, b) {
                    return a - b
                }),
            });
        }
    }
    exportOrderInfo = () => {
        if (this.state.selectedRowKeys.length === 0) {
            message.error("请选择要导出的数据!");
        } else {
            this.setState({
                loading: true,
                isExporting: true,
            })
            let exportOrderDTO = {};
            exportOrderDTO.ids = this.state.selectedRowKeys;
            exportOrderDTO.userRole = userRole;
            Axios({
                method: 'post',
                url: '/order/exportOrderInfo',
                data: JSON.stringify(exportOrderDTO),
                responseType: 'blob'
            }).then(res => {
                if (res.status === 200) {
                    const blob = new Blob([res.data])
                    const downloadElement = document.createElement('a');
                    const href = window.URL.createObjectURL(blob); //创建下载的链接
                    downloadElement.href = href;
                    downloadElement.download = '订单数据.xlsx'; //下载后文件名
                    document.body.appendChild(downloadElement);
                    downloadElement.click(); //点击下载
                    document.body.removeChild(downloadElement); //下载完成移除元素
                    window.URL.revokeObjectURL(href); //释放掉blob对象
                    this.setState({
                        loading: false,
                        isExporting: false,
                    })
                } else if (res.code === 401) {
                    message.error(res.message);
                    this.setState({
                        loading: false,
                        isExporting: false,
                    })
                }
            }).catch(err => {
                console.log(err);
                this.setState({
                    loading: false,
                    isExporting: false,
                })
            });
        }
    }
    // 导出当月台次：选择年月，按站点分组导出当月已完成台次
    exportMonthCompleted = () => {
        const {monthExportYear, monthExportMonth} = this.state;
        if (!monthExportYear || !monthExportMonth) {
            message.warning('请选择年份和月份');
            return;
        }
        this.setState({isMonthExporting: true});
        Axios({
            method: 'get',
            url: '/order/exportMonthCompleted',
            params: {year: monthExportYear, month: monthExportMonth},
            responseType: 'blob'
        }).then(res => {
            if (res.status === 200) {
                const blob = new Blob([res.data])
                const downloadElement = document.createElement('a');
                const href = window.URL.createObjectURL(blob);
                downloadElement.href = href;
                downloadElement.download = monthExportYear + '年' + monthExportMonth + '月当月台次.xlsx';
                document.body.appendChild(downloadElement);
                downloadElement.click();
                document.body.removeChild(downloadElement);
                window.URL.revokeObjectURL(href);
                this.setState({isMonthExporting: false, monthExportVisible: false});
            } else {
                this.setState({isMonthExporting: false});
            }
        }).catch(err => {
            console.log(err);
            this.setState({isMonthExporting: false});
        });
    }
    groupChange = (value, option) => {
        this.setState({
            groupUser: option.key,
        }, () => {
            this.searchOrder();
        })
    }
    showQRCode = () => {
        Axios({
            method: 'get',
            url: PATH_URL.BASE_URL + "/" + PATH_URL.MAJOR_ACCOUNT_QR_CODE_URL + "/" + userName,
        }).then(res => {
            if (res.data != null) {
                this.setState({
                    qrCodeVisible: true,
                    qrCodeImage: res.data,
                });
            }
        }).catch(err => {
            console.log(err);
        });
    }

    handleTableChange = (pagination, filters, sorter) => {
        const field = (sorter && sorter.field) ? sorter.field : 'orderTime';
        const type = (sorter && sorter.order) ? sorter.order : 'descend';
        if (field === this.state.sortField && type === this.state.sortType) {
            return;
        }
        this.setState({
            sortField: field,
            sortType: type,
        });
        setTimeout(() => {
            this.initData();
        }, 100);
    }

    handleResize = (key) => (newWidth) => {
        this.setState(prev => ({
            colWidths: {...prev.colWidths, [key]: newWidth},
        }));
    }
    buildResizableColumns = (columns) => {
        return columns.map(col => {
            if (col.key === 'action' || col.children || col.width === 0) {
                return col;
            }
            const key = col.key || col.dataIndex;
            return {
                ...col,
                width: this.state.colWidths[key] || col.width || 120,
                ellipsis: col.ellipsis === undefined ? true : col.ellipsis,
                onHeaderCell: () => ({
                    width: this.state.colWidths[key] || col.width || 120,
                    onResize: this.handleResize(key),
                }),
            };
        });
    }

    render() {
        const rowSelection = {
            selectedRowKeys: [...this.state.selectedRowKeys],
            fixed: true,
            onChange: this.onSelectChange,
            onSelect: this.rowOnSelect,
            onSelectAll: this.onSelectAll,
        };
        const columns = this.buildResizableColumns([
            {
                title: '车牌',
                dataIndex: 'licensePlate',
                key: 'licensePlate',
                fixed: 'left',
                width: 120,
            },
            {
                title: '车主姓名',
                dataIndex: 'ownerName',
                key: 'ownerName',
                fixed: 'left',
                width: 150,
                ellipsis: true,
            },
            {
                title: '车辆类型',
                dataIndex: 'carModel',
                key: 'carModel',
                width: 130,
                ellipsis: true,
            },
            {
                title: '车辆注册时间',
                dataIndex: 'registrationTime',
                key: 'registrationTime',
                width: 170,
                render: (v) => (v ? String(v).substring(0, 10) : '-'),
            },
            {
                title: '车主手机号',
                dataIndex: 'ownerTel',
                key: 'ownerTel',
                width: 120,
                render: ownerTel => {
                    if (userRole === 3) {
                        return ownerTel.replace(/^(\d{3})\d{4}(\d{4})$/, "$1****$2");
                    } else {
                        return ownerTel;
                    }
                }
            },
            {
                title: '预约站点',
                dataIndex: 'siteName',
                key: 'siteName',
                width: 200,
                ellipsis: true,
            },
            {
                title: '站点电话',
                dataIndex: 'siteTel',
                key: 'siteTel',
                width: 120,
            },
            {
                title: '预约人',
                dataIndex: 'orderByName',
                key: 'orderByName',
                width: 120,
            },
            {
                title: '预约人账户',
                dataIndex: 'orderBy',
                key: 'orderBy',
                width: 120,
            },
            {
                title: '预约人手机号',
                dataIndex: 'orderByTel',
                key: 'orderByTel',
                width: 120,
            },
            {
                title: '所属组员',
                dataIndex: 'groupUser',
                key: 'groupUser',
                width: (userRole === 5 || this.state.source === "5") ? 150 : 0,
                ellipsis: true,
            },
            {
                title: '组员姓名',
                dataIndex: 'groupName',
                key: 'groupName',
                width: (userRole === 5 || this.state.source === "5") ? 150 : 0,
                ellipsis: true,
            },
            ...(userRole === 3 ? [] : [{
                title: '渠道',
                dataIndex: 'source',
                key: 'source',
                width: 120,
                render: source => {
                    switch (source) {
                        case 0:
                            return '管理员';
                        case 1:
                            return '线上电呼';
                        case 2:
                            return '业务团队';
                        case 4:
                            return '车主';
                        case 5:
                            return '大客户';
                        default:
                            return '管理员';
                    }
                }
            }]),
            {
                title: '预约时间',
                dataIndex: 'orderTime',
                key: 'orderTime',
                width: 165,
                render: (v) => <span style={{background: '#ffffff', color: '#000000'}}>{v ? String(v).substring(0, 10) : '-'}</span>,
            },
            {
                title: '预约状态',
                dataIndex: 'status',
                key: 'status',
                width: 120,
                render: status => {
                    switch (status) {
                        case 0:
                            return '已预约';
                        case 1:
                            return '已完成';
                        case 2:
                            return '已取消';
                        default:
                            return '已预约';
                    }
                }
            },
            {
                title: '完成验车时间',
                dataIndex: 'completeTime',
                key: 'completeTime',
                width: 165,
                render: (v) => <span style={{color: '#0000ff'}}>{v ? String(v).substring(0, 10) : '-'}</span>,
            },
            {
                title: '订单创建时间',
                dataIndex: 'gmtCreate',
                key: 'gmtCreate',
                width: 165,
                render: (v) => (v ? String(v).substring(0, 10) : '-'),
            },
            ...(userRole === 3 ? [] : [{
                title: '备注',
                dataIndex: 'remarks',
                key: 'remarks',
                width: 200,
                ellipsis: true,
            }]),
            {
                title: '操作',
                key: 'action',
                fixed: 'right',
                width: userRole === 0 ? 250 : 150,
                render: (text, record) => (
                    <Space size="small">
                        {userRole === 0 ? (this.state.userPermission != null && this.state.userPermission.includes('300032') ? (
                            <a onClick={this.showOrder.bind(this, record)}>查看</a>) : null) : (
                            <a onClick={this.showOrder.bind(this, record)}>查看</a>)
                        }

                        {(record.status === 0 || ((userRole === 0 || userRole === 3) && record.status !== 1 && record.status !== 2)) ? (
                            (userRole === 0 ? (this.state.userPermission != null && this.state.userPermission.includes('300033') ? (
                                <a onClick={this.showEditOrder.bind(this, record)}>修改</a>) : null) : (userRole === 3 ? null : (
                                <a onClick={this.showEditOrder.bind(this, record)}>修改</a>)))) : null
                        }
                        {record.status === 0 && (userRole === 0 || userRole === 3) ? (
                            userRole === 0 ? (this.state.userPermission != null && this.state.userPermission.includes('300034') ? (
                                <a
                                    onClick={this.showChangeOrderStatus.bind(this, record, 1)}>置为完成</a>) : null) : (<a
                                onClick={this.showChangeOrderStatus.bind(this, record, 1)}>置为完成</a>)) : null
                        }
                        {record.status === 1 && userRole === 0 ? (
                            userRole === 0 ? (this.state.userPermission != null && this.state.userPermission.includes('300035') ? (
                                <a
                                    onClick={this.showChangeOrderStatus.bind(this, record, 0)}>置为预约</a>) : null) : (<a
                                onClick={this.showChangeOrderStatus.bind(this, record, 0)}>置为预约</a>)) : null
                        }
                        {(record.status === 0 && userRole !== 3) ? (
                            userRole === 0 ? (this.state.userPermission != null && this.state.userPermission.includes('300036') ? (
                                    <a style={{'color': '#eea236'}}
                                       onClick={this.showCancelOrder.bind(this, record)}>取消订单</a>) : null) :
                                <a style={{'color': '#eea236'}}
                                   onClick={this.showCancelOrder.bind(this, record)}>取消订单</a>) : null
                        }
                        {(userRole === 0 && record.status !== 1 && this.state.userPermission != null && this.state.userPermission.includes('300037')) ? (
                            <a style={{'color': '#d43f3a'}}
                               onClick={this.showDeleteOrder.bind(this, record)}>删除</a>) : null}
                    </Space>
                ),
            },
        ]);
        if (userRole === 3) {
            columns.splice(7, 5)
        }
        if (userRole === 6) {
            columns.splice(8, 2)
        }
        return (
            <div className={style['content']} id='content'>
                <div className={style['content_info']}>
                    <Tabs defaultActiveKey="1" tabBarStyle={userRole === 3 ? {} : {display: 'none'}}>
                        <TabPane tab="订单列表" key="1">
                            <Form layout='inline' className="filter-form">
                                <Form.Item
                                    label="时间筛选"
                                    style={{marginTop: '5px', marginBottom: '5px'}}>
                                    <Select value={this.state.timeType} onChange={this.timeTypeChange}
                                            style={{width: 119}}>
                                        <Select.Option value="orderTime">预约时间</Select.Option>
                                        <Select.Option value="completeTime">完成时间</Select.Option>
                                        {userRole === 3 ? null : (<Select.Option value="registrationTime">车辆注册时间</Select.Option>)}
                                        <Select.Option value="orderCreateTime">订单创建时间</Select.Option>
                                    </Select>
                                    <RangePicker locale={zh_CN} style={{width: 323, marginLeft: 5}}
                                                 value={this.state.timeRange}
                                                 onChange={this.handleTimeSelect}/>
                                </Form.Item>
                        <Form.Item
                            label="其他筛选"
                            style={{width: 560, marginTop: '5px', marginBottom: '5px'}}>
                            <Select value={this.state.searchField} onChange={this.searchFieldChange}
                                    style={{width: 119}}>
                                <Select.Option value="licensePlate">预约车牌</Select.Option>
                                {userRole === 3 ? null : (<Select.Option value="ownerName">车主姓名</Select.Option>)}
                                {userRole === 3 ? null : (<Select.Option value="ownerTel">车主电话</Select.Option>)}
                                {userRole === 3 ? null : (<Select.Option value="carModel">车辆类型</Select.Option>)}
                                {userRole === 0 ? (<Select.Option value="orderByName">预约人</Select.Option>) : null}
                                {userRole === 0 ? (<Select.Option value="orderBy">预约人账户</Select.Option>) : null}
                                {userRole === 0 ? (<Select.Option value="groupUserName">组员账户</Select.Option>) : null}
                                {userRole === 0 ? (<Select.Option value="groupUserRealName">组员姓名</Select.Option>) : null}
                            </Select>
                            <Input placeholder="请输入搜索内容" id="searchValue"
                                       value={this.state.searchValue}
                                       style={{width: 213, marginLeft: 5}}
                                   onChange={this.inputChange}/>
                        </Form.Item>
                        {
                            userRole === 3 ? (null) : (<Form.Item
                                label="预约站点"
                                name="siteName"
                                style={{width: 236, marginTop: '5px', marginBottom: '5px'}}>
                                <Select style={{width: '85%'}} onChange={this.siteChange}
                                                showSearch allowClear={true}
                                                dropdownMatchSelectWidth={false}
                                                dropdownStyle={{minWidth: 'max-content'}}>
                                    {
                                        this.state.allSiteData != null ?
                                            this.state.allSiteData.map(item => {
                                                return (<Select.Option key={item.siteName}
                                                                       value={item.siteName}>{item.siteName}</Select.Option>)
                                            }) : null
                                    }
                                </Select>
                            </Form.Item>)
                        }
                        <Form.Item
                            label="预约状态"
                            name="status"
                            style={{width: 250, marginTop: '5px', marginBottom: '5px'}}>
                            <Select style={{width: '85%'}} onChange={this.statusChange} allowClear={true}>
                                <Select.Option value="0">已预约</Select.Option>
                                <Select.Option value="1">已完成</Select.Option>
                                <Select.Option value="2">已取消</Select.Option>
                            </Select>
                        </Form.Item>
                        {
                            userRole === 5 ? (<Form.Item
                                label="所属组"
                                name="groupUser"
                                style={{width: 236, marginTop: '5px', marginBottom: '5px'}}>
                                <Select style={{width: '85%'}} onChange={this.groupChange}
                                        showSearch allowClear={true}>
                                    {
                                        this.state.allGroupUserData != null ?
                                            this.state.allGroupUserData.map(item => {
                                                return (<Select.Option key={item.userName}
                                                                       value={item.groupName}>{item.groupName}</Select.Option>)
                                            }) : null
                                    }
                                </Select>
                            </Form.Item>) : (null)
                        }
                        {
                            (userRole === 0 && this.state.userPermission != null && this.state.userPermission.length > 0 && this.state.userPermission.includes('300038')) ? (
                                <Form.Item
                                    label="渠道"
                                    name="source"
                                    style={{width: 182, marginTop: '5px', marginBottom: '5px'}}>
                                    <Select style={{width: '85%'}} onChange={this.sourceChange} allowClear={true}>
                                        {this.state.userPermission != null && this.state.userPermission.includes('300039') ? (
                                            <Select.Option value="0">管理员</Select.Option>) : null
                                        }
                                        {this.state.userPermission != null && this.state.userPermission.includes('300040') ? (
                                            <Select.Option value="1">线上电呼</Select.Option>) : null
                                        }
                                        {this.state.userPermission != null && this.state.userPermission.includes('300041') ? (
                                            <Select.Option value="2">业务团队</Select.Option>) : null
                                        }
                                        {this.state.userPermission != null && this.state.userPermission.includes('300042') ? (
                                            <Select.Option value="4">车主</Select.Option>) : null
                                        }
                                        {this.state.userPermission != null && this.state.userPermission.includes('300073') ? (
                                            <Select.Option value="5">大客户</Select.Option>) : null
                                        }
                                    </Select>
                                </Form.Item>) : null
                        }
                        {
                            userRole === 3 ? null : (<Form.Item
                                label="备注"
                                name="remarks"
                                style={{width: 540, marginTop: '5px', marginBottom: '5px'}}
                                rules={[
                                    {max: 50, message: '备注不能多于50个字符'}
                                ]}>
                                <Input placeholder="请输入备注"
                                       style={{width: '85%'}}
                                       onChange={this.inputChange}/>
                            </Form.Item>)
                        }
                        <Form.Item
                            style={{marginTop: '5px', marginBottom: '5px'}}>
                            <Button type="primary" onClick={this.searchOrder}>查询</Button>
                            <Button type="primary" htmlType="reset" style={{'marginLeft': '10px'}}
                                    onClick={this.resetSearch}>重置</Button>
                            {
                                userRole === 3 ? (null) : (userRole === 0 && this.state.userPermission != null && this.state.userPermission.includes('300030') ? (
                                    <Button type="primary" style={{'marginLeft': '10px'}}
                                            onClick={this.showAddOrder}>新增预约</Button>) : null)
                            }
                            {
                                userRole === 3 ? (null) : (userRole !== 0 ? (
                                    <Button type="primary" style={{'marginLeft': '10px'}}
                                            onClick={this.showAddOrder}>新增预约</Button>) : null)
                            }
                            {userRole === 0 && this.state.userPermission != null && this.state.userPermission.includes('300031') ? (
                                <Button type="primary" style={{'marginLeft': '5px'}}
                                        onClick={this.exportOrderInfo}
                                        disabled={this.state.isExporting}>导出</Button>) : null
                            }
                            {/* 导出当月台次：权限码 300132 */}
                            {userRole === 0 && this.state.userPermission != null && this.state.userPermission.includes('300132') ? (
                                <Button type="primary" style={{'marginLeft': '5px'}}
                                        onClick={() => this.setState({monthExportVisible: true, monthExportYear: null, monthExportMonth: null})}>导出当月台次</Button>) : null
                            }
                            {/* 我的二维码：仅组员(role=6)显示（线上电呼/业务团队/大客户已按要求隐藏） */}
                            {(userRole === 6) ? (
                                <Button type="primary" style={{'marginLeft': '5px'}}
                                        onClick={this.showQRCode}>我的二维码</Button>) : null
                            }
                            {/* 导出：仅车主(role=4)显示（线上电呼/业务团队/大客户/合作站点已按要求隐藏） */}
                            {userRole === 4 ? (
                                <Button type="primary" style={{'marginLeft': '5px'}}
                                        onClick={this.exportOrderInfo}
                                        disabled={this.state.isExporting}>导出</Button>) : null
                            }
                            <Button type="primary" style={{'marginLeft': '5px'}}
                                    onClick={this.searchTheSameDayOrder}>今日预约订单</Button>

                        </Form.Item>
                    </Form>
                    {/* 导出当月台次：选择年月弹窗 */}
                    <Modal
                        title="导出当月台次"
                        visible={this.state.monthExportVisible}
                        onOk={this.exportMonthCompleted}
                        onCancel={() => this.setState({monthExportVisible: false})}
                        okText="导出"
                        okButtonProps={{disabled: this.state.isMonthExporting}}
                        cancelButtonProps={{disabled: this.state.isMonthExporting}}
                        width={420}>
                        <div style={{display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 0'}}>
                            <span>年份：</span>
                            <Select placeholder="选择年份" style={{width: 130}}
                                    value={this.state.monthExportYear}
                                    onChange={(v) => this.setState({monthExportYear: v})}>
                                {(() => {
                                    const opts = [];
                                    const curYear = new Date().getFullYear();
                                    for (let y = curYear; y >= curYear - 6; y--) opts.push(<Select.Option key={y} value={y}>{y}</Select.Option>);
                                    return opts;
                                })()}
                            </Select>
                            <span>月份：</span>
                            <Select placeholder="选择月份" style={{width: 130}}
                                    value={this.state.monthExportMonth}
                                    onChange={(v) => this.setState({monthExportMonth: v})}>
                                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(m => (
                                    <Select.Option key={m} value={m}>{m}月</Select.Option>
                                ))}
                            </Select>
                        </div>
                        <div style={{color: '#999', fontSize: '12px'}}>将按所选月份导出各站点当月已完成台次（两列：站点名称、已完成台次）。</div>
                    </Modal>
                    <div>
                        <Modal
                            width={700}
                            title={
                                <div
                                    style={{
                                        width: '100%',
                                        cursor: 'move',
                                    }}>
                                    新增
                                </div>
                            }
                            visible={this.state.addVisible}
                            onOk={this.addOrder}
                            onCancel={this.handleCancel}>
                            <Form
                                ref={this.addFormRef}>
                                <Row>
                                    <Col span={11}>
                                        <Form.Item
                                            label="预约账户"
                                            name="userName"
                                            rules={[{
                                                required: true, validator: async (_, value, callback) => {
                                                    if (Util.isTel(value)) {
                                                        return Promise.resolve()
                                                    } else {
                                                        return Promise.reject('请输入正确的手机号码');
                                                    }
                                                }
                                            }]}>
                                            <Input placeholder="车主手机号"/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={11} style={{'marginLeft': '20px'}}>
                                        <Form.Item
                                            label="车主姓名"
                                            name="ownerName"
                                            rules={[{required: true, message: '请输入姓名'}]}>
                                            <Input/>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={11}>
                                        <Form.Item
                                            label="预约车牌"
                                            name="licensePlate"
                                            rules={[{
                                                required: true, validator: async (_, value, callback) => {
                                                    if (value.indexOf(' ') >= 0) {
                                                        return Promise.reject('车牌号不允许有空格！');
                                                    } else {
                                                        return Promise.resolve();
                                                    }
                                                }
                                            }]}>
                                            <Input/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={11} style={{'marginLeft': '20px'}}>
                                        <Form.Item
                                            label="车主手机"
                                            name="ownerTel"
                                            rules={[{
                                                required: true, validator: async (_, value, callback) => {
                                                    if (Util.isTel(value)) {
                                                        return Promise.resolve()
                                                    } else {
                                                        return Promise.reject('请输入正确的手机号码');
                                                    }
                                                }
                                            }]}>
                                            <Input/>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={11}>
                                        <Form.Item
                                            label="车辆类型"
                                            name="carModel"
                                            rules={[{required: true, message: '请输入车辆类型'}]}>
                                            <Select dropdownMatchSelectWidth={false}>
                                                {
                                                    this.state.carModelData != null ?
                                                        this.state.carModelData.map(item => {
                                                            return (<Select.Option key={item.modelName}
                                                                                   value={item.modelName}>{item.modelName}</Select.Option>)
                                                        }) : null
                                                }
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={11} style={{'marginLeft': '20px'}}>
                                        <Form.Item
                                            label="预约站点"
                                            name="siteName"
                                            rules={[{required: true, message: '请输入站点名称'}]}>
                                            <Select showSearch dropdownMatchSelectWidth={false}>
                                                {
                                                    this.state.siteData != null ?
                                                        this.state.siteData.map(item => {
                                                            return (<Select.Option key={item.siteName}
                                                                                   value={item.siteName}>{item.siteName}</Select.Option>)
                                                        }) : null
                                                }
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={11}>
                                        <Form.Item
                                            label="预约时间"
                                            name="orderTime"
                                            rules={[{required: true, message: '请选择预约时间'}]}>
                                            <DatePicker locale={zh_CN} style={{"width": "100%"}}/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={11} style={{'marginLeft': '20px'}}>
                                        <Form.Item
                                            label="车辆注册时间"
                                            name="registrationTime"
                                            rules={[{required: true, message: '请选择车辆注册时间'}]}>
                                            <DatePicker locale={zh_CN} style={{"width": "100%"}}/>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Form.Item
                                    label="备注"
                                    name="remarks">
                                    <TextArea rows={2} style={{padding: '4px 8px'}}/>
                                </Form.Item>
                            </Form>
                        </Modal>
                        <Modal
                            title={
                                <div
                                    style={{
                                        width: '100%',
                                        cursor: 'move',
                                    }}>
                                    查看
                                </div>
                            }
                            visible={this.state.viewVisible}
                            onOk={this.handleCancel}
                            onCancel={this.handleCancel}>
                            <Form
                                ref={this.viewFormRef}>
                                <Row>
                                    <Col span={11}>
                                        <Form.Item
                                            label="预约账户"
                                            name="userName">
                                            <Input disabled/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={11} style={{'marginLeft': '30px'}}>
                                        <Form.Item
                                            label="车主姓名"
                                            name="ownerName">
                                            <Input disabled/>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={11}>
                                        <Form.Item
                                            label="预约车牌"
                                            name="licensePlate">
                                            <Input disabled/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={11} style={{'marginLeft': '30px'}}>
                                        <Form.Item
                                            label="车主手机"
                                            name="ownerTel">
                                            <Input disabled/>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={11}>
                                        <Form.Item
                                            label="预约站点"
                                            name="siteName">
                                            <Input disabled/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={11} style={{'marginLeft': '30px'}}>
                                        <Form.Item
                                            label="车辆类型"
                                            name="carModel">
                                            <Input disabled/>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                {userRole === 3 ?
                                    null : (<Form.Item
                                        label="预约人"
                                        name="orderByName"
                                        style={{"width": "463px"}}>
                                        <Input disabled/>
                                    </Form.Item>)
                                }
                                {userRole === 3 ?
                                    null : (<Form.Item
                                        label="预约人账户"
                                        name="orderBy"
                                        style={{"width": "463px"}}>
                                        <Input disabled/>
                                    </Form.Item>)
                                }
                                <Form.Item
                                    label="预约时间"
                                    name="orderTime"
                                    style={{"width": "463px"}}>
                                    <Input disabled/>
                                </Form.Item>
                                <Form.Item
                                    label="车辆注册时间"
                                    name="registrationTime"
                                    style={{"width": "463px"}}>
                                    <Input disabled/>
                                </Form.Item>
                                {
                                    userRole === 3 ? null : (<Form.Item
                                        label="备注"
                                        name="remarks"
                                        style={{"width": "463px"}}>
                                        <TextArea disabled rows={4}/>
                                    </Form.Item>)
                                }
                            </Form>
                        </Modal>
                        <Modal
                            width={700}
                            title={
                                <div
                                    style={{
                                        width: '100%',
                                        cursor: 'move',
                                    }}>
                                    修改
                                </div>
                            }
                            visible={this.state.editVisible}
                            onOk={this.updateOrder}
                            onCancel={this.handleCancel}>
                            <Form
                                ref={this.editFormRef}>
                                <Form.Item
                                    label="预约ID"
                                    name="id"
                                    hidden="true">
                                    <Input/>
                                </Form.Item>
                                <Form.Item
                                    label="预约状态"
                                    name="status"
                                    hidden="true">
                                    <Input/>
                                </Form.Item>
                                <Row>
                                    <Col span={11}>
                                        <Form.Item
                                            label="预约账户"
                                            name="userName"
                                            rules={[{required: true, message: '请输入姓名'}]}>
                                            <Input disabled/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={11} style={{'marginLeft': '20px'}}>
                                        <Form.Item
                                            label="车主姓名"
                                            name="ownerName"
                                            rules={[{required: true, message: '请输入姓名'}]}>
                                            <Input/>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={11}>
                                        <Form.Item
                                            label="预约车牌"
                                            name="licensePlate"
                                            rules={[{required: true, message: '请输入车牌'}]}>
                                            <Input disabled/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={11} style={{'marginLeft': '20px'}}>
                                        <Form.Item
                                            label="车主手机"
                                            name="ownerTel"
                                            rules={[{
                                                required: true, validator: async (_, value, callback) => {
                                                    if (Util.isTel(value)) {
                                                        return Promise.resolve()
                                                    } else {
                                                        return Promise.reject('请输入正确的手机号码');
                                                    }
                                                }
                                            }]}>
                                            <Input/>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={11}>
                                        <Form.Item
                                            label="预约站点"
                                            name="siteName"
                                            rules={[{required: true, message: '请输入站点名称'}]}>
                                            <Select showSearch dropdownMatchSelectWidth={false}>
                                                {
                                                    this.state.siteData != null ?
                                                        this.state.siteData.map(item => {
                                                            return (<Select.Option key={item.siteName}
                                                                                   value={item.siteName}>{item.siteName}</Select.Option>)
                                                        }) : null
                                                }
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={11} style={{'marginLeft': '20px'}}>
                                        <Form.Item
                                            label="车辆类型"
                                            name="carModel"
                                            rules={[{required: true, message: '请输入车辆类型'}]}>
                                            <Select dropdownMatchSelectWidth={false}>
                                                {
                                                    this.state.carModelData != null ?
                                                        this.state.carModelData.map(item => {
                                                            return (<Select.Option key={item.modelName}
                                                                                   value={item.modelName}>{item.modelName}</Select.Option>)
                                                        }) : null
                                                }
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={11}>
                                        <Form.Item
                                            label="预约时间"
                                            name="orderTime"
                                            rules={[{required: true, message: '请选择预约时间'}]}>
                                            <DatePicker locale={zh_CN} style={{"width": "100%"}}/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={11} style={{'marginLeft': '20px'}}>
                                        <Form.Item
                                            label="车辆注册时间"
                                            name="registrationTime"
                                            rules={[{required: true, message: '请选择车辆注册时间'}]}>
                                            <DatePicker locale={zh_CN} style={{"width": "100%"}}/>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Form.Item
                                    label="备注"
                                    name="remarks">
                                    <TextArea rows={2} style={{padding: '4px 8px'}}/>
                                </Form.Item>
                            </Form>
                        </Modal>
                        <Modal
                            title={
                                <div
                                    style={{
                                        width: '100%',
                                        cursor: 'move',
                                    }}>
                                    二维码
                                </div>
                            }
                            visible={this.state.qrCodeVisible}
                            onOk={this.handleCancel}
                            onCancel={this.handleCancel}>
                            <Form>
                                <Form.Item>
                                    <Image
                                        width={470}
                                        height={450}
                                        fallback="data:image/png;base64,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"
                                        src={this.state.qrCodeImage}/>
                                </Form.Item>
                            </Form>
                        </Modal>
                    </div>
                    <Table columns={columns}
                           size="small"
                           className="module-table"
                           dataSource={this.state.data}
                           rowKey={columns => columns.id}
                           rowSelection={userRole !== 6 ? rowSelection : null}
                           loading={this.state.loading}
                           style={{'marginTop': '20px'}}
                           tableLayout="fixed"
                           scroll={{x: 3000}}
                           components={{header: {cell: ResizableTitle}}}
                           onChange={this.handleTableChange}
                           pagination={{
                               showTotal: () => `共 ${this.state.total} 条`,
                               onShowSizeChange: (current, pageSize) => {
                                   this.setState({
                                       current: current,
                                       pageSize: pageSize
                                   });
                                   setTimeout(() => {
                                       this.initData();
                                   }, 100);
                               },
                               total: this.state.total,
                               current: this.state.current,
                               pageSize: this.state.pageSize,
                               onChange: (current, pageSize) => {
                                   this.setState({
                                       current: current,
                                       pageSize: pageSize
                                   });
                                   setTimeout(() => {
                                       this.initData();
                                   }, 100);
                               }
                           }}/>
                    {
                        userRole !== 6 ? (<div style={{
                            marginTop: "-38px",
                            marginLeft: "8px",
                            display: (this.state.data === null || this.state.data.length === 0) ? 'none' : ''
                        }}>
                            < Checkbox onChange={this.exportAllSelect}
                                       checked={this.state.isCheckAll}
                                       disabled={this.state.selectAllLoading}>{this.state.checkboxText}</Checkbox><span style={{marginLeft:8,fontSize:13,color:'#606266'}}>已选 <b style={{color:'#1890ff'}}>{this.state.selectedRowKeys.length}</b> 条</span>
                            {
                                this.state.selectAllLoading ? (
                                    <span style={{
                                        marginLeft: '8px',
                                        fontSize: '14px',
                                        color: '#67c23a',
                                        verticalAlign: 'middle'
                                    }}>全选中 {this.state.selectAllProgress}%</span>
                                ) : null
                            }
                        </div>) : null
                    }
                        </TabPane>
                    </Tabs>

                </div>
            </div>
        )
    }
}

export default OrderInfo;